
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M13.15 33.22L30 58.15l16.85-24.93M34.52 51.35l-7.87-11.17M39.8 43.39l-6.56-9.23"}}),_c('path',{attrs:{"d":"M46.71 20h-1a28.25 28.25 0 00.29-2.87A16 16 0 1014.29 20h-1a6.86 6.86 0 000 13.72h9.65v4a3 3 0 006.06 0v-4h17.71a6.86 6.86 0 000-13.72z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    